import PropTypes from 'prop-types';
import { Row, Col, FormGroup, Stack, DropdownSelect } from 'components/ui';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const VerbindungZurPerson = ({ update, formData: vaxFormData, validation }) => {
	const [t] = useTranslation();
	const vaxRelationships = useSelector(
		(state) => state.masterData.vaxRelationships
	);
	const getRelationshipOptions = (relationships) => {
		let relationOptions = [];
		if (relationships && relationships.length) {
			relationOptions = relationships.map((vaxRelation) => ({
				value: vaxRelation.vax_relationship_id,
				text: t(
					'master_data.vax_relationship.' + vaxRelation.relationship_i18n_key
				),
			}));
		}

		relationOptions.unshift({
			value: '',
			text: t('common.bitte_waehlen') + ' *',
		});
		return relationOptions;
	};
	const relationOptions = getRelationshipOptions(vaxRelationships);
	return (
		<Row xs={12} style={{ marginTop: '20px' }}>
			<Col xs={6}>
				<FormGroup className='mb-3' style={{ marginTop: '10px' }}>
					<Stack gap={3}>
						<DropdownSelect
							onChange={(e) => {
								update({
									vax_relationship_id: e.target.value,
								});
							}}
							value={vaxFormData?.vax_relationship_id}
							isInvalid={validation['vax_relationship_id']}
							options={relationOptions}
						/>
					</Stack>
				</FormGroup>
			</Col>
			<Col xs={6}></Col>
		</Row>
	);
};

VerbindungZurPerson.propTypes = {
	update: PropTypes.func,
	formData: PropTypes.object,
	validation: PropTypes.object,
};

export { VerbindungZurPerson };
